// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2T8qt","buttons":"SendReceipts_buttons__32o6q","email":"SendReceipts_email__a0K5r","bookApptTitle":"SendReceipts_bookApptTitle__LOzkj"};